export const useDesign = () => {
  const variables = { namespace: "lz", elNamespace: "el", block: "-", elem: "__", mod: "--" };
  /**
   * @param scope 类名
   * @returns 返回空间名-类名
   */
  const b = (scope: string): string => {
    return `${variables.namespace}${variables.block}${scope}`;
  };
  /**
   * @param $el 类名
   * @returns 返回空间名-类名
   */
  const e = ($b: string, $el: string) => {
    return `${$b}${variables.elem}${$el}`;
  };

  /**
   * @param $m 类名
   * @returns 返回空间名-类名
   */
  const m = ($b: string, $m: string) => {
    return `${$b}${variables.mod}${$m}`;
  };
  return {
    variables,
    b,
    e,
    m,
  };
};
